import { useQuery } from "react-query";
import { useSearchApi } from "./useSearchApi";

const queryKeys = {
    search: ["search"],
};

export const useSearchData = (propertyId, checkin, checkout, occupancy, enabled = true) => {
    const { searchAvailableRooms } = useSearchApi();

    const queryResults = useQuery({
        queryKey: [...queryKeys.search, propertyId, checkin, checkout, occupancy],
        queryFn: () => searchAvailableRooms(propertyId, checkin, checkout, occupancy),
        cacheTime: 0,
        staleTime: 0,
        enabled: !!propertyId && !!checkin && !!checkout && !!occupancy && enabled,
    });

    return {
        queryResults,
    };
};
